import { default as olMousePosition } from 'ol/control/MousePosition.js';
import {Control} from '../Control.js';
import Library from '../Library.js';

export class DateLabel extends Control {

    constructor( map, settings = {} ){
        settings["name"] = 'date_label';
        if( settings['target'] == undefined ) settings['target'] = "date_label";
        if( settings['format'] == undefined ) settings['format'] = "";
        super( map, settings );
        this.getState();

        let div = document.getElementById( this.target );
        if( div == undefined) return;

        let date = Library.formatDate( "", this.map.secs );
        div.innerHTML = date;

    }

    refresh(){
        let div = document.getElementById( this.target );
        if( div == undefined) return 0;

        let date = Library.formatDate( "", this.map.secs );
        div.innerHTML = date;
    }

    setLabel( val ){
        let div = document.getElementById( this.target );
        if( div == undefined) return 0;

        div.innerHTML = val;
    }
}
